/* eslint-disable max-len */
/* eslint-disable new-cap */

import React, {useMemo} from 'react';
import {Popup} from 'semantic-ui-react';
import {validatePricesColumns} from './validatePricesColumns';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';

const TableValidateData = ({
  dataTable = [],
}) => {
  const data = useMemo(() => dataTable, [dataTable]);
  const columns = useMemo(() => validatePricesColumns || [], []);


  const customColumnsHook = (columns, i) => [
    ...columns.map((column, i) => {
      return {
        ...column,
        'Cell': ({row}) => {
          let text = row.original[column.id];
          if (['fob', 'color_value', 'commision', 'shipping_cost', 'cif'].includes(column.id)) {
            const dollarUS = Intl.NumberFormat('de-DE');
            text = row.original[column.id] ? `$ ${dollarUS.format(row.original[column.id])}` : '';
          }
          if (Object.keys(row?.original.errors).includes(column.id)) {
            return (
              <Popup
                trigger={
                  <div className='prices-validation__red-cell'>{text || '-'}</div>
                }
                content={row?.original.errors[column.id]}
                position='top center'
                size='small'
                style={{'maxWidth': '150px'}}
                inverted
              />
            );
          }
          return <span >{text}</span>;
        },
      };
    }),
  ];

  return (
    <CommercialTable
      columns={columns}
      data={data}
      tableType='fixed'
      tableWrapperStyles='priorization-dates-table-wrapper'
      isSmallCell={true}
      customColumnsHook={customColumnsHook}
    />
  );
};

export default TableValidateData;
